module.exports = __webpack_public_path__ + "img/blue-map.ed6fb012.gif";